export function displayRecordedCost(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return 'Not linked';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: value > 0 && value < .01 ? 4 : 2, maximumFractionDigits: value > 0 && value < .01 ? 4 : 2 }).format(value);
}
export function operationStatus(status: string) {
  const labels: Record<string, string> = { suspected_stalled: 'Suspected stalled', failed: 'Failed', pending_confirmation: 'Awaiting confirmation', aborted_insufficient_credits: 'Credit limit', partial: 'Partial', completed: 'Completed', running: 'Running' };
  return { label: labels[status] || status.replaceAll('_', ' '), tone: status === 'failed' ? 'error' : status === 'suspected_stalled' || status === 'partial' ? 'warning' : 'neutral' };
}
export function displayElapsed(start: string | null, end: string | null) {
  if (!start || !end) return '—';
  const seconds = Math.floor((Date.parse(end) - Date.parse(start)) / 1000);
  if (!Number.isFinite(seconds) || seconds < 0) return '—';
  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}
